import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import usePark from "common/hooks/usePark";
import useAuth from "common/hooks/useAuth";
import ParkForm from "./ParkForm";

function Park() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { park: currentPark } = usePark();
  const { refreshPark, park } = usePark();
  const { setAlert } = useContext(AlertsContext);

  const id = currentPark?.id || (router.query.id as string);

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "parks",
    id,
    {
      populate: ["logo"],
    }
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(
        currentUser?.isSuperadmin && !currentPark?.id ? "/parks" : "/"
      );
    }
  }, [setAlert, router, error, currentUser, currentPark, t]);

  const onSubmit = useCallback(
    async (dataPark: any) => {
      const newPark = { ...dataPark };

      try {
        if (newPark.id) {
          await updateItem(newPark.id, newPark);
          if (park) {
            await refreshPark(newPark.id);
          }
        } else {
          await saveItem(newPark);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem, refreshPark, park]
  );

  return isFetching || (id && !item) ? null : (
    <ParkForm onSubmit={onSubmit} park={item} />
  );
}

export default Park;
